/**
 * Icon — renders one Hugeicons free icon (the only icon set allowed in V2).
 * ─────────────────────────────────────────────────────────────────────────
 *   import { Wallet01Icon } from '@hugeicons/core-free-icons';   // named import (tree-shaken)
 *   <Icon icon={Wallet01Icon} />                 → <svg class="hi"> 18px (from v2.css `svg.hi`)
 *   <Icon icon={Wallet01Icon} size={20} />       → width/height 20px inline
 *   <Icon icon={Wallet01Icon} className="xs" />  → extra classes (e.g. `.hi.xs`)
 *   <Icon icon={Wallet01Icon} strokeWidth={2} /> → overrides every stroked element
 *   <Icon icon={…} aria-label="محفظة" />          → announced (role="img") instead of aria-hidden
 *
 * The package exports each icon as an array of [tag, attrs] pairs
 * (path / circle / rect / ellipse with camelCased attributes and a `key`).
 * Colour comes from `currentColor`, size from CSS (`svg.hi`, `.btn .hi`, …).
 */
import React from 'react';

export default function Icon({ icon, size, className = '', strokeWidth, style, ...rest }) {
  if (!Array.isArray(icon)) return null;
  const labelled = rest['aria-label'] != null || rest['aria-labelledby'] != null;
  const sizeStyle = size != null ? { width: size, height: size, ...style } : style;

  return (
    <svg
      className={className ? `hi ${className}` : 'hi'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      {...(labelled ? { role: 'img' } : { 'aria-hidden': true })}
      style={sizeStyle}
      {...rest}
    >
      {icon.map(([tag, attrs], i) => {
        const { key, ...props } = attrs || {};
        if (strokeWidth != null && props.strokeWidth != null) props.strokeWidth = strokeWidth;
        return React.createElement(tag, { key: key ?? i, ...props });
      })}
    </svg>
  );
}

export { Icon };
